import { STORY_POINTS } from '@/constants/STORY_POINTS.ts'
import { useUpdateCache } from '@/requests/apollo/useUpdateCache.ts'
import { useMutateStory } from '@/requests/mutations/useMutateStory.ts'
import { isTemporaryId } from '@/utils/key.ts'
import type { ApolloError } from '@apollo/client/errors'

export const useMutateStoryType = (storyId: string) => {
  const { mutate } = useMutateStory(storyId)
  const { updateStory } = useUpdateCache()

  return (value: StoryType, onError?: (error: ApolloError) => void) => {
    if (isTemporaryId(storyId)) {
      updateStory(storyId, {
        storyType: value,
        estimate: STORY_POINTS.UNESTIMATED,
      })
      return Promise.resolve()
    }

    return mutate(
      { storyType: value },
      {
        onError,
        update: (cache) => {
          cache.modify({
            id: cache.identify({ __typename: 'Story', id: storyId }),
            fields: {
              storyType: () => value,
              estimate: () => STORY_POINTS.UNESTIMATED,
            },
          })
        },
      },
    )
  }
}
